var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverageDfiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 53,
    viewBox: "0 0 61 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.0739 25.0946C28.0636 25.0164 27.9909 24.9615 27.9135 24.9718L23.8559 25.5166L21.0439 24.766L22.0324 23.1216L24.7621 21.9512L24.8279 21.9231C24.9006 21.8922 24.9342 21.8079 24.9027 21.7358C24.8718 21.6631 24.7875 21.6295 24.7155 21.661L21.8356 22.8966L21.3722 23.6684L19.2224 22.959L18.2394 21.2014L18.1804 21.0964C18.142 21.0278 18.055 21.0031 17.9864 21.0416C17.9179 21.08 17.8932 21.1671 17.9316 21.2357L19.9875 24.9115L19.5254 24.764L17.2906 22.8342L15.1614 22.7477C15.0832 22.7436 15.0161 22.806 15.0133 22.8849C15.0099 22.9638 15.0716 23.0304 15.1504 23.0331L17.1803 23.1154L18.0893 23.9003L18.6672 25.8555L14.2915 26.9504C14.2147 26.9696 14.1688 27.0471 14.188 27.1232C14.2044 27.1877 14.2627 27.2316 14.3264 27.2316C14.3381 27.2316 14.3497 27.2303 14.3614 27.2275L17.5477 26.4303L18.9798 27.2385L16.021 30.0142C15.9635 30.0684 15.9607 30.1583 16.0149 30.2159C16.043 30.2461 16.0807 30.2612 16.1191 30.2612C16.154 30.2612 16.189 30.2481 16.2164 30.2227L18.1187 28.4377L20.1849 28.2463L19.6625 32.4174L19.6571 32.462C19.6571 32.462 19.6571 32.4626 19.6571 32.4633L19.642 32.5813C19.6324 32.6595 19.6879 32.7309 19.766 32.7405C19.7722 32.7412 19.7777 32.7418 19.7839 32.7418C19.8545 32.7418 19.9162 32.689 19.9251 32.617L19.9409 32.4928L20.2905 29.7507L21.8494 29.9545L22.177 30.6364L22.4841 31.2758C22.5184 31.3471 22.6034 31.3773 22.6747 31.3423C22.746 31.308 22.7755 31.223 22.7412 31.1516L22.0728 29.759L21.5827 28.7388L21.7452 26.855L24.4125 28.5433L25.8987 29.4839C25.9652 29.5257 26.0537 29.5065 26.0955 29.4393C26.138 29.3727 26.1181 29.2842 26.0509 29.2424L25.1522 28.6737L24.3405 28.1598L23.2094 25.8952L24.3858 25.7375L27.7709 25.2833L27.9526 25.2586C28.0307 25.2483 28.0855 25.1763 28.0753 25.0981L28.0739 25.0946ZM21.2214 23.9181L20.4639 25.1783L19.4281 23.3267L21.2207 23.9181H21.2214ZM20.5619 27.6117L20.6545 27.4649L21.7006 29.6437L20.3254 29.464L20.5619 27.6117ZM20.6881 26.8756L20.2864 27.5122L20.2301 27.952L18.456 28.1159L19.4562 27.1774L17.948 26.3268L19.0236 26.0578L18.4869 24.2426L19.3815 25.0151L20.1897 25.273L20.4543 25.7457L20.8903 25.0199L23.1183 25.6147L21.1398 25.8801L21.4751 26.6286L21.3373 28.2284L20.6874 26.8742L20.6881 26.8756ZM23.8723 27.8614L21.7342 26.5079L21.558 26.1141L22.9092 25.933L23.873 27.8621L23.8723 27.8614Z",
    fill: "#005FC8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.1041 51.9892C36.8376 49.426 33.445 40.4795 39.023 32.3935C45.5756 22.8945 44.1806 17.4609 44.1806 17.4609C44.1806 17.4609 50.2214 19.637 51.6048 29.1842C52.3059 34.0244 51.09 40.631 51.09 40.631C51.09 40.631 56.2608 39.8268 55.2452 30.2218",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.5605 52.0034C58.8271 49.4403 62.2196 40.4792 56.6416 32.3931C56.1262 31.6453 55.6597 30.9231 55.2378 30.2266",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.1543 52.0004H11.458V46.5068C11.458 46.5068 11.7417 42.2109 7.16541 42.2109H0.46875",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.5431 6.8797L29.7351 5.07031L3.35938 29.1038H11.4591V37.0676",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.3584 52.0043V37.0703H33.2617",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36.8018 0.75H34.2743L31.2635 10.0533L33.7362 9.64167L30.2832 21.0271L38.384 6.49072L34.8241 6.88656L36.8018 0.75Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    y1: -0.75,
    x2: 8.83182,
    y2: -0.75,
    transform: "matrix(0.706844 0.70737 -0.706844 0.70737 36.5264 12.0391)",
    stroke: "#005FC8",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverageDfiIcon);
export default __webpack_public_path__ + "static/media/coverage-dfi-icon.2094d9a6.svg";
export { ForwardRef as ReactComponent };